const lt = {
  pleaseEnterUsername: "Įveskite naudotojo vardą",
  cannotFriendYourself: "Negalite išsiųsti draugystės užklausos sau.",
  friendRequestSent: "Draugystės užklausa išsiųsta!",
  failedToSendRequest: "Nepavyko išsiųsti užklausos",
  linkCopied: "Nuoroda nukopijuota į iškarpinę!",
  backToInvites: "Grįžti prie kvietimų",
  sendFriendRequestByUsername: "Siųsti draugystės užklausą pagal naudotojo vardą",
  enterUsername: "Įveskite naudotojo vardą",
  send: "Siųsti",
  yourInviteQrCode: "Jūsų kvietimo QR kodas",
  inviteLink: "Kvietimo nuoroda",
  scanQrOrUseLink: "Nuskaitykite šį QR kodą arba naudokite šią nuorodą draugystės užklausai išsiųsti",
  copyInviteLink: "Kopijuoti kvietimo nuorodą",
  goToItem: "Eiti į elementą",
  verificationEmailSent: "Patvirtinimo el. laiškas išsiųstas! Patikrinkite savo pašto dėžutę.",
  verificationEmailFailed: "Nepavyko išsiųsti patvirtinimo el. laiško. Bandykite dar kartą.",
  verifyYourEmail: "Patvirtinkite savo el. paštą",
  verifyEmailInstructions: "Patvirtinkite savo el. pašto adresą, kad galėtumėte naudotis paskyra. Patikrinkite savo pašto dėžutę dėl patvirtinimo nuorodos.",
  sending: "Siunčiama...",
  resendVerificationEmail: "Siųsti patvirtinimo el. laišką dar kartą",
  login: "Prisijungti",
  register: "Registruotis",
  home: "Pagrindinis",
  calendar: "Kalendorius",
  friends: "Draugai",
  profile: "Profilis",
  logout: "Atsijungti",
  loading: "Įkeliama...",
  language: "Kalba",
  calendarSelectPlaceSuggestion: "Pasirinkite vietą iš pasiūlymų, kad būtų pridėtos koordinatės.",
  calendarSelectDateAndTime: "Pasirinkite datą ir laiką.",
  calendarPositiveDuration: "Įveskite teigiamą trukmę.",
  calendarFutureDateRequired: "Renginio data ir laikas turi būti ateityje.",
  calendarCreateEventFailed: "Nepavyko sukurti renginio. Bandykite dar kartą.",
  cancel: "Atšaukti",
  createNewEvent: "Sukurti naują renginį",
  week: "Savaitė",
  month: "Mėnuo",
  eventTitle: "Pavadinimas",
  date: "Data",
  time: "Laikas",
  duration: "Trukmė",
  endsAt: "Baigiasi",
  place: "Vieta",
  searchForPlace: "Ieškoti vietos",
  placeSearchTip: "Patarimas: pradėkite rašyti ir pasirinkite rezultatą, kad būtų pridėtos koordinatės.",
  description: "Aprašymas",
  createEvent: "Sukurti renginį",
  today: "Šiandien",
  previousMonth: "Ankstesnis mėnuo",
  nextMonth: "Kitas mėnuo",
  previous: "Ankstesnis",
  next: "Kitas",
  mondayShort: "Pr",
  tuesdayShort: "An",
  wednesdayShort: "Tr",
  thursdayShort: "Kt",
  fridayShort: "Pn",
  saturdayShort: "Št",
  sundayShort: "Sk",
  more: "Daugiau",
  mustRespondWillBeforeReposting: "Prieš perskelbdami turite pasirinkti „Dalyvausiu“",
  event: "Renginys",
  backToCalendar: "Grįžti į kalendorių",
  addToGoogleCalendar: "Pridėti prie Google kalendoriaus",
  when: "Kada",
  where: "Kur",
  openLocationInGoogleMaps: "Atidaryti vietą Google Maps",
  hosts: "Organizatoriai",
  yourResponse: "Jūsų atsakymas",
  currentResponse: "Dabartinis atsakymas",
  response_will: "Dalyvausiu",
  response_might: "Galbūt dalyvausiu",
  response_wont: "Nedalyvausiu",
  willRunIntoYou: "Būtinai užsuksiu",
  mightDropBy: "Gal užsuksiu",
  wontCome: "Neateisiu",
  repostToMyFriends: "Perskelbti draugams",
  responses: "Atsakymai",
  willAttend: "Dalyvaus",
  reposted: "Perskelbta",
  mightAttend: "Galbūt dalyvaus",
  cancelEvent: "Atšaukti renginį",
  cancellationEmailNoticeBefore: "Žmonės, kurie atsakė",
  cancellationEmailNoticeAfter: "gaus el. laišką apie renginio atšaukimą.",
  optionalCancellationMessage: "Pasirenkama žinutė dalyviams (iki 1000 simbolių)",
  confirmCancelEvent: "Patvirtinti renginio atšaukimą",
  clear: "Išvalyti",
  confirmCancellation: "Patvirtinti atšaukimą",
  confirmCancellationMessage: "Ar tikrai norite atšaukti šį renginį? Patvirtinti dalyviai bus informuoti, o renginys pašalintas.",
  eventCancelledNotified: "Renginys atšauktas. Informuota",
  attendees: "dalyvių",
  failedToCancelEvent: "Nepavyko atšaukti renginio",
  back: "Atgal",
  cancelled: "Atšaukta",
  ok: "Gerai",
  forgotPassword: "Pamiršote slaptažodį?",
  email: "El. paštas",
  passwordResetLinkSent: "Jei paskyra egzistuoja, slaptažodžio atkūrimo nuoroda buvo išsiųsta.",
  passwordResetRequestFailed: "Nepavyko pateikti slaptažodžio atkūrimo užklausos.",
  sendResetLink: "Siųsti atkūrimo nuorodą",
  addFriend: "Pridėti draugą",
  incomingRequests: "Gaunamos užklausos",
  accept: "Priimti",
  deny: "Atmesti",
  myFriends: "Mano draugai",
  noFriendsYet: "Dar neturite draugų. Pradėkite juos pridėdami!",
  seeProfile: "Peržiūrėti profilį",
  noEventsToRespondTo: "Nėra renginių, į kuriuos reikėtų atsakyti",
  allCaughtUp: "Viskas peržiūrėta. Sugrįžkite vėliau naujiems draugų renginiams.",
  events: "Renginiai",
  unknown: "Nežinoma",
  noDescriptionProvided: "Aprašymas nepateiktas.",
  will: "Dalyvausiu",
  maybe: "Galbūt",
  wont: "Nedalyvausiu",
  userNotFound: "Naudotojas nerastas",
  friendRequestSentSuccessfully: "Draugystės užklausa sėkmingai išsiųsta!",
  friendInvitation: "Draugystės kvietimas",
  sendFriendRequest: "Siųsti draugystės užklausą",
  loginToSendFriendRequest: "Prisijunkite, kad išsiųstumėte draugystės užklausą",
  chooseLanguage: "Pasirinkite kalbą",
  invalidCredentials: "Neteisingi prisijungimo duomenys. Bandykite dar kartą.",
  username: "Naudotojo vardas",
  password: "Slaptažodis",
  forgotPasswordQuestion: "Pamiršote slaptažodį?",
  dontHaveAccount: "Neturite paskyros?",
  registerHere: "Registruokitės čia",
  invalidProfilePhotoType: "Netinkamas failo tipas. Įkelkite JPEG, PNG, GIF arba WebP paveikslėlį.",
  invalidFileExtension: "Netinkamas failo plėtinys",
  allowedExtensions: "Leidžiami",
  fileTooLarge: "Failas per didelis",
  maximumFileSize: "Maksimalus dydis",
  profilePhotoRemoved: "Profilio nuotrauka pašalinta.",
  failedToRemoveProfilePhoto: "Nepavyko pašalinti profilio nuotraukos",
  profileUpdatedSuccessfully: "Profilis sėkmingai atnaujintas!",
  failedToUpdateProfile: "Nepavyko atnaujinti profilio",
  privateEmailExplanation: "Tik jūs galite matyti savo el. paštą, kad išvengtumėte nepageidaujamų žinučių už platformos ribų",
  yourEmailIsPrivate: "Jūsų el. paštas yra privatus.",
  profilePhoto: "Profilio nuotrauka",
  removePhoto: "Pašalinti nuotrauką",
  firstName: "Vardas",
  lastName: "Pavardė",
  tellPeopleAboutYourself: "Papasakokite apie save",
  whereToContactMe: "Kur su manimi susisiekti",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Išsaugoti",
  notSet: "Nenustatyta",
  editProfile: "Redaguoti profilį",
  imageToCrop: "Apkarpomas vaizdas",
  zoom: "Mastelis",
  usePhoto: "Naudoti nuotrauką",
  name: "Vardas",
  whereToContact: "Kur susisiekti",
  removeFriendship: "Pašalinti draugystę",
  confirmRemoveFriend: "Patvirtinti draugo pašalinimą",
  confirmRemoveFriendBefore: "Ar tikrai norite pašalinti",
  confirmRemoveFriendAfter: "iš savo draugų sąrašo?",
  friendRemoved: "Draugas pašalintas.",
  failedToRemoveFriend: "Nepavyko pašalinti draugo.",
  confirmRemove: "Patvirtinti pašalinimą",
  error: "Klaida",
  removed: "Pašalinta",
  passwordsDoNotMatch: "Slaptažodžiai nesutampa",
  registrationFailed: "Registracija nepavyko. Bandykite dar kartą.",
  confirmPassword: "Patvirtinkite slaptažodį",
  alreadyHaveAccount: "Jau turite paskyrą?",
  loginHere: "Prisijunkite čia",
  passwordResetSuccessfully: "Slaptažodis sėkmingai atkurtas.",
  failedToResetPassword: "Nepavyko atkurti slaptažodžio.",
  resetPassword: "Atkurti slaptažodį",
  newPassword: "Naujas slaptažodis",
  confirmNewPassword: "Patvirtinkite naują slaptažodį",
  setNewPassword: "Nustatyti naują slaptažodį",
  emailVerifiedSuccessfully: "El. paštas sėkmingai patvirtintas!",
  emailVerificationFailed: "Patvirtinimas nepavyko. Nuoroda gali būti negaliojanti arba pasibaigusi.",
  verifying: "Tvirtinama...",
  verified: "Patvirtinta!",
  redirectingToHome: "Peradresuojama į pagrindinį puslapį...",
  verificationFailed: "Patvirtinimas nepavyko",
  goToHome: "Eiti į pagrindinį puslapį",
  about: "Apie",
  aboutConceptTitle: "Koncepcija",
  aboutCreatorIntroduction: "Sveiki, aš Crypt0, alpinistas ir Run Into Me kūrėjas.",
  aboutCreatorStory: "Sukūriau šią svetainę, nes mėgstu bendrauti ir per daug laiko skyriau bendrų laipiojimų planavimui.",
  aboutPlanningProblem: "Norėjau visiems iš karto pranešti, kada ir kur laipiosiu, be oficialaus kvietimo.",
  aboutDeveloperSolution: "Tada prisiminiau, kad esu programuotojas ir galiu pats sukurti sprendimą.",
  aboutWelcome: "Sveiki atvykę į Run Into Me, kur draugams galite pranešti apie veiklas, prie kurių jie gali prisijungti be spaudimo.",
  aboutCallToAction: "Paskelbkite čia kitą veiklą, kuri smagesnė kartu!",
  aboutTutorialTitle: "Vadovas",
  aboutCalendarCreateEvent: "Kalendoriaus lange taip pat galite sukurti naują renginį.",
  aboutEventColorsIntroduction: "Spalvos rodo dalyvavimo būseną:",
  aboutColorGold: "Aukso",
  aboutColorGoldDescription: "Jūs organizuojate renginį.",
  aboutColorGreen: "Žalia",
  aboutColorGreenDescription: "Dalyvausite renginyje.",
  aboutColorOrange: "Oranžinė",
  aboutColorOrangeDescription: "Atsakėte „galbūt“.",
  aboutColorBlue: "Mėlyna",
  aboutColorBlueDescription: "Dar neatsakėte.",
  aboutColorGray: "Pilka",
  aboutColorGrayDescription: "Atmetėte kvietimą.",
  aboutCalendarEventDetails: "Spustelėkite renginį, kad peržiūrėtumėte informaciją ir atsakytumėte.",
  aboutFriendPageTitle: "Draugų puslapis",
  aboutFriendPageDescription: "Įveskite naudotojo vardą arba siųskite nuorodą / QR kodą.",
  aboutHomePageTitle: "Pagrindinis puslapis",
  aboutHomePageDescription: "Peržiūrėkite renginius ir praneškite, ar dalyvausite.",
  aboutRepostScreenTitle: "Pakartotinio skelbimo langas",
  aboutGoogleCalendarDescription: "Šiuo mygtuku pridėkite renginį į Google kalendorių.",
  aboutRepostDescription: "Patvirtinę dalyvavimą galite paskelbti renginį draugams.",
};

export default lt;